import * as React from "react";
import { WidgetWrapper } from "uxp/components";
import { IUIPropertyDefinitionMap, IWidgetTemplateProps, registerCardTemplate } from "../../../common/common";
import { generateIconProp, generateIconPropAsSting } from "../../../common/icon-selector/IconEditor";
import { SelectableItem, selectUIProps } from "../../../common/SelectableItem";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { extractIconProperties, IconProperty } from "../../../common/ui-props/IconProperty";
import { ButtonProperty, extractButtonProperties } from "../../../common/ui-props/ButtonProperty";
import { ContainerProperty, extractContainerProperties } from "../../../common/ui-props/ContainerProperty";
import { extractTextProperties, TextProperty } from "../../../common/ui-props/TextProperty";
import ActionButton from "../../../common/components/ActionButton";
import { replaceWithData } from "../../../../util";
import { IContextData, useInitialContextData } from "../../../../hooks/useContextData";

const XPRProps: IUIPropertyDefinitionMap = {
    'topContainer': ContainerProperty({
        background: {
            image: {
                image: '',
                position: 'center',
                size: 'cover'
            }
        }
    }),
    'bottomContainer': ContainerProperty({
        background: {
            color: 'white'
        },
        text: {
            color: '#424242'
        }
    }),
    'icon': IconProperty({ icon: 'solidCalendarAlt', color: '', size: '18px' }),
    'title': TextProperty({
        text: '',
        color: '',
        align: 'left',
        size: '12px'
    }, 'Title'),
    'subTitle': TextProperty({
        text: '',
        color: '',
        align: 'left',
        size: '12px'
    }, 'Sub Title'),
    'button': ButtonProperty({
        label: '',
        onClick: { type: 'open-url' },
        color: '',
        backgroundColor: '',
        icon: {
            icon: '',
            position: 'left',
            color: '',
            size: '12px'
        }
    })
}


const XPR: React.FunctionComponent<IWidgetTemplateProps> = props => {

    let uiProps = props?.uiProps || {};

    // top container 
    let { styles: topContainerStyles } = extractContainerProperties(uiProps.topContainer)
    if (!topContainerStyles.backgroundImage) topContainerStyles.backgroundImage = "url('https://unsplash.it/600')"

    // bottom container 
    let { styles: bottomContainerStyles } = extractContainerProperties(uiProps.bottomContainer)

    // icon
    let { icon, styles: iconStyles } = extractIconProperties(uiProps.icon, 'solidCalendarAlt')

    // text 
    let { text: title, styles: titleStyles } = extractTextProperties(uiProps.title, 'Book a')
    let { text: subTitle, styles: subTitleStyles } = extractTextProperties(uiProps.subTitle, 'Meeting')

    // button 
    let { label, onClick, icon: buttonIcon, iconPosition, iconStyles: buttonIconStyles, buttonStyles } = extractButtonProperties(uiProps.button, 'Book')

    const [loading, setLoading] = React.useState(false)
    let [contextData, setContextData] = React.useState<IContextData>({})

    const { isLoading, initialContextData } = useInitialContextData(props)

    React.useEffect(() => {
        setLoading(isLoading)
        setContextData(prev => ({ ...prev, ...initialContextData }))
    }, [isLoading, initialContextData])

    React.useEffect(() => {
        console.log('context_data_________', contextData)
    }, [contextData])

    return <WidgetWrapper className="uxp-simple-card-template">
        <div className="top">
            <SelectableItem
                designer={props.designer}
                props={selectUIProps(uiProps, XPRProps, 'topContainer')}
                contextData={contextData}
            >
                <div className="image" style={topContainerStyles}></div>
            </SelectableItem>
        </div>
        <div className="bottom">
            <SelectableItem
                designer={props.designer}
                props={selectUIProps(uiProps, XPRProps, 'bottomContainer')}
                contextData={contextData}
            >
                <div className="bottom-cont" style={bottomContainerStyles}>
                    <div className="left">
                        <div className="icon-cont-block">
                            <SelectableItem
                                designer={props.designer}
                                props={selectUIProps(uiProps, XPRProps, 'icon')}
                                contextData={contextData}
                            >
                                <div className="icon-container">
                                    <FontAwesomeIcon icon={generateIconProp(icon)} style={iconStyles} />
                                </div>
                            </SelectableItem>
                        </div>

                        <div className="titles">
                            <SelectableItem
                                designer={props.designer}
                                props={selectUIProps(uiProps, XPRProps, 'title')}
                                contextData={contextData}
                            >
                                <div className="title" style={titleStyles}>{replaceWithData(title, contextData)}</div>
                            </SelectableItem>
                            <SelectableItem
                                designer={props.designer}
                                props={selectUIProps(uiProps, XPRProps, 'subTitle')}
                                contextData={contextData}
                            >
                                <div className="sub-title" style={subTitleStyles} >{replaceWithData(subTitle, contextData)}</div>
                            </SelectableItem>
                        </div>
                    </div>

                    <div className="right">
                        <SelectableItem
                            designer={props.designer}
                            props={selectUIProps(uiProps, XPRProps, 'button')}
                            contextData={contextData}
                        >
                            <ActionButton
                                designer={props.designer}
                                uxpContext={props.uxpContext}
                                title={replaceWithData(label, contextData)}
                                action={onClick}
                                styles={buttonStyles}
                                icon={generateIconPropAsSting(buttonIcon)}
                                iconPosition={iconPosition}
                                iconStyles={buttonIconStyles}
                                onReloadWidget={() => { }}
                                contextData={contextData}
                            />
                        </SelectableItem>
                    </div>
                </div>
            </SelectableItem>
        </div>
    </WidgetWrapper>
}


registerCardTemplate({
    id: 'simple-card',
    name: "Simple Card",
    description: 'A simple card widget, with option to configure a background image, an icon , title and a button. The button can invoke any arbitrary action.',
    template: XPR,
    icon: generateIconProp('creditCard'),
    complexity: 'easy',
});